import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "../Header";
import Field from "../../../../../Settings/Content/Components/Field";

import { RequestUpdateAgentPolicy } from "../../../../../../store/actions/integrationsActions";

const MIN_MAX_VALUES = {
  policySyncSeconds: [30, 3600],
  statusIntervalSeconds: [30, 300],
};

const PollingForm = ({ selectedHost }) => {
  const dispatch = useDispatch();

  const policy = useSelector((state) => state.integrations.agentPolicy);
  const updatePolicyLoading = useSelector((state) => state.integrations.updatePolicyLoading);

  const [pollingUI, setPollingUI] = useState({
    ...policy?.settings?.polling,
  });

  const inputChangeHandler = (e) => {
    const { name, value } = e.target;
    setPollingUI((prev) => ({
      ...prev,
      [name]: value === "" ? "" : Number(value),
    }));
  };

  const blurHandler = (e) => {
    const { name, value } = e.target;
    const limits = MIN_MAX_VALUES[name];
    if (!limits) return;

    const [min, max] = limits;
    let newValue = Number(value);

    if (newValue < min) newValue = min;
    if (newValue > max) newValue = max;

    setPollingUI((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const checkSaveButtonDisabled = () => {
    const backend = policy?.settings?.polling;
    const ui = pollingUI;

    if (!backend || !ui) return true;

    if (
      backend.policySyncSeconds !== ui.policySyncSeconds ||
      backend.statusIntervalSeconds !== ui.statusIntervalSeconds
    ) {
      return false;
    }

    return true;
  };

  const updateAgentSettingsHandler = (e) => {
    e.preventDefault();
    if (updatePolicyLoading) return;

    dispatch(
      RequestUpdateAgentPolicy({
        id: policy.id,
        settings: {
          ...policy.settings,
          polling: pollingUI,
        },
        host: selectedHost,
      }),
    );
  };

  return (
    <>
      <Header
        policy={policy}
        selectedHost={selectedHost}
        toggleProps={{
          show: false,
        }}
      />

      <form className="agent-policy-form">
        <div className="agent-policy-form__line">
          <Field
            label="Policy Sync in seconds"
            tooltipText="Min: 30, Max: 3600"
            width="220px"
            name="policySyncSeconds"
            value={pollingUI.policySyncSeconds}
            onChange={inputChangeHandler}
            onBlur={blurHandler}
            type="number"
          />
          <Field
            label="Status Interval in seconds"
            tooltipText="Min: 30, Max: 300"
            width="220px"
            name="statusIntervalSeconds"
            value={pollingUI.statusIntervalSeconds}
            onChange={inputChangeHandler}
            onBlur={blurHandler}
            type="number"
          />
        </div>

        <button
          className="primary-button"
          disabled={checkSaveButtonDisabled()}
          onClick={updateAgentSettingsHandler}>
          Save
        </button>
      </form>
    </>
  );
};

export default PollingForm;
